import { MdCheck } from 'react-icons/md';
import { useEffect } from 'react';
import { ReportingControllerBaseConfig } from '../../../../../base';
import { BooleanElementController } from './booleanElementInterface';
import { BooleanElementViewProps } from './booleanElementProps';

export function createBooleanElementController(
    config: ReportingControllerBaseConfig
): BooleanElementController {
    return {
        useProps(props): BooleanElementViewProps {
            return {
                input: {
                    isChecked: props.value ?? false,
                    onChange() {
                        props.onChange(!props.value);
                    },
                },
            };
        },
    };
}
